import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './result-summary.scss';

const ResultSummary = ({ text = '', count = 0 }) => (
  <div className={css.component}>
		<div>{text} ({count})</div>
  </div>
);

ResultSummary.propTypes = {
    text: PropTypes.string,
    count: PropTypes.number
};

export default ResultSummary;
